/* Drawer two-pane category rail (Figma HEADER_MO 2781:6940).
 *
 * Prestige's own sub-menu behaviour is a slide-over panel with a back button:
 * theme.js binds every `.header-sidebar__main-panel .header-sidebar__linklist
 * [aria-controls]` button to `openCollapsiblePanel`. The rail below uses
 * neither of those class names and lives outside `.header-sidebar__linklist`,
 * so nothing in theme.js can see these buttons — this file is the only thing
 * driving them, and the two implementations cannot fight over the same click.
 *
 * Every pane is server-rendered and only `hidden` is toggled, so a tap swaps
 * the right-hand pane in place: the promo banner, the quick links and the rest
 * of the rail stay on screen, and there is no transition and no back button.
 * With JS unavailable the server-chosen default pane simply stays open.
 */
(function () {
  'use strict';

  var NAV_SELECTOR = '[data-peth-drawer-nav]';

  function activate(nav, button) {
    var targetId = button.getAttribute('data-peth-pane');
    if (!targetId) return;

    var buttons = nav.querySelectorAll('.peth-drawer-rail__item[data-peth-pane]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', buttons[i] === button ? 'true' : 'false');
    }

    var panes = nav.querySelectorAll('.peth-drawer-pane');
    for (var j = 0; j < panes.length; j++) {
      var isTarget = panes[j].id === targetId;
      panes[j].hidden = !isTarget;

      if (!isTarget) {
        /* Collapse any third-level accordion left open in the pane we are
           leaving, so coming back to it shows the same state as a fresh open. */
        var open = panes[j].querySelectorAll('details[open]');
        for (var k = 0; k < open.length; k++) open[k].open = false;
      }
    }

    /* The panes column scrolls with the drawer body, not on its own; reset the
       body to the top so a swap never lands the shopper mid-list. */
    var scroller = nav.closest('.peth-drawer-scroller');
    if (scroller) scroller.scrollTop = 0;
  }

  function bind(nav) {
    if (nav.dataset.pethDrawerNavBound === 'true') return;
    nav.dataset.pethDrawerNavBound = 'true';

    nav.addEventListener('click', function (event) {
      var button = event.target.closest('.peth-drawer-rail__item[data-peth-pane]');
      if (!button || !nav.contains(button)) return;

      event.preventDefault();
      activate(nav, button);
    });
  }

  function bindAll(root) {
    var navs = (root || document).querySelectorAll(NAV_SELECTOR);
    for (var i = 0; i < navs.length; i++) bind(navs[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindAll(document); });
  } else {
    bindAll(document);
  }

  /* The header is a section: the theme editor re-renders it wholesale, which
     replaces the nav element and drops the listener with it. */
  document.addEventListener('shopify:section:load', function (event) {
    bindAll(event.target);
  });
})();
